<header class="position-relative">

  <div class="header-wrp uk-flex uk-flex-between uk-flex-middle {{_extraClass}}">

    <div class="left-panel uk-flex uk-flex-middle w-20">
      <div class="logo-box logo-shadow scrolltoshow">

        <a [routerLink]="['/'+headerSelectedCity.toLowerCase()+'/deals']" *ngIf="isStandardProduct">
          <img src="assets/images/logo.png" alt="">
        </a>
        <a [routerLink]="['/'+headerSelectedCity.toLowerCase()+'/exclusives']" *ngIf="!isStandardProduct">
          <img src="assets/images/logo.png" alt="">
        </a>
      </div>
      <div class="location-dropdown scrolltoshow">
        <a (click)="showCitySelection($event.target)">
          <p>
            <ng-container *ngIf="headerSelectedCity">{{headerSelectedCity === 'delhi' ? 'Delhi-NCR' : headerSelectedCity
              | titlecase}} </ng-container>
            &nbsp; <i class="fa fa-angle-down"></i>
          </p>
        </a>
      </div>
    </div>
    <!--left-panel-->

    <div class="middle-panel scrolltoshow hideMobile" *ngIf="_displayProductSwitch === true ">
      <ul uk-tab class="swtitch-tab">
        <li class="{{!isStandardProduct?'uk-active':''}}">
          <a [routerLink]="['/'+this.headerSelectedCity.toLowerCase()+'/exclusives']">Exclusive</a>
        </li>
        <li class="{{isStandardProduct?'uk-active':''}}"><a
            [routerLink]="['/'+this.headerSelectedCity.toLowerCase()+'/deals']">Deals</a></li>
      </ul>
    </div>

    <div class="right-panel w-25">
      <ul class="uk-flex uk-flex-middle uk-flex-right">

        <li *ngIf="currentUser">
          <div class="welcome-user uk-flex uk-flex-middle">
            <div class="icons">
              <i class="fa fa-user-circle-o" gaEvent="click" gaCategory="Link" gaAction="Click" gaLabel="Login"
                href="#modal-center" uk-toggle *ngIf="!currentUser"></i>
              <i class="fa fa-user-circle-o" gaEvent="click" gaCategory="Link" gaAction="Click" gaLabel="Login"
                (click)="openMyAccount()" uk-toggle *ngIf="currentUser"></i>
            </div>
            <div class="info" (click)="openMyAccount()">
              <p>&nbsp; Welcome Back</p>
              <h4>&nbsp; {{currentUser.first_name}}</h4>
            </div>
          </div>
        </li>

        <li>
          <div class="welcome-user uk-flex uk-flex-middle">

            <ng-container *ngIf="!currentUser">
              <div class="icons mr-10">
                <i class="fa fa-user-circle-o" gaEvent="click" gaCategory="Link" gaAction="Click" gaLabel="Login"
                  href="#modal-center" uk-toggle *ngIf="!currentUser"></i>
              </div>
              <div class="info">
                <a gaEvent="click" gaCategory="Link" gaAction="Click" gaLabel="Login" class="login" href="#modal-center"
                  uk-toggle *ngIf="!currentUser">
                  login
                </a>
              </div>
            </ng-container>

            <div class="info">
              <a gaEvent="click" gaCategory="Link" gaAction="Click" gaLabel="My Account" class="login"
                href="javascript:void(0)" *ngIf="currentUser">
                <a class="login" type="button"><span><i class="fa fa-user" aria-hidden="true"></i></span> Logout</a>

                <div uk-drop="mode: click; delay-hide:200" class="logout-drop">
                  <div class="uk-card uk-card-body uk-card-default">
                    <p class="blue-text" style="color: black">Do you want to logout?</p>
                    <button class="btn-yellow " (click)="doLogout()"> Yes</button>
                    <button class="btn-default" (click)="hideLogout()"> No</button>
                  </div>
                </div>

              </a>
            </div>
          </div>
        </li>

        <li>
          <a (click)="showSearchForm()" class="openSearch" title="Search">
            <i class="fa fa-search" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" class="openMenu" title="Menu" (click)="openMenu($event.target)">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--right-panel-->

  </div>
  <!--header-wrp-->

  <!--SEARCH SIDENAV-->
  <div class="search-sidenav-wrp">
    <div class="close-btn">
      <button class="uk-modal-close-default closehamburger" type="button" uk-close (click)="closeSearchForm()"></button>
    </div>
    <div class="search-sidenav-inner">

      <div class="border-form-input mt-2">
        <form #searchForm="ngForm" (submit)="searchProducts()">
          <div class="form-group">
            <div class="uk-inline">
              <span class="uk-form-icon">
                <i class="fa fa-search"></i>
              </span>
              <app-autosearch [standardProduct]="isStandardProduct"></app-autosearch>
            </div>
          </div>
        </form>
      </div>

      <!--
      <div class="f-categories mt-1">
        <h4>Featured Categories</h4>
        <a href="">Once in a Lifetime</a>
        <a href="">Superhero</a>
        <a href="">Disconnect</a>
        <a href="">Luxury</a>
      </div>

      <div class="what-to-do">
        <h4>Not sure what to do?</h4>
        <figure>
          <img src="assets/images/banner-1.jpg" alt="Trulli" style="width:100%">
          <figcaption>World at your Doorstep</figcaption>
        </figure>
        <figure>
          <img src="assets/images/banner-1.jpg" alt="Trulli" style="width:100%">
          <figcaption>Campervan Experience</figcaption>
        </figure>
      </div>
      -->

    </div>
  </div>
  <!--search-sidenav-wrp-->


  <div class="hamburger-overlay ">
    <div class="hamburger-menu-main" id="main-ham">
      <div class="close-btn">
        <button class="uk-modal-close-default" type="button" uk-close (click)="closeMenu()"></button>
      </div>
      <div class="selected-city-card uk-flex">
        <div class="icons">
          <img src="assets/images/city-model/mumbai.png" alt="">
        </div>
        <div class="info" (click)="showCitySelection($event.target)">
          <h4>Currently in
          </h4>
          <p>
            <ng-container *ngIf="headerSelectedCity">{{headerSelectedCity | titlecase}} </ng-container>
            <img src="assets/images/icons/arrow-bottom.png" alt="">
          </p>
        </div>
      </div>
      <div class="hamburger-accord">
        <ul uk-accordion>
          <li class="uk-open">
            <a class="uk-accordion-title" href="#">EXCLUSIVES</a>
            <div class="uk-accordion-content mt-1">
              <ul class="hamburger-accord-innerlist">
                <li>
                  <a [routerLink]="['/']">All</a>
                </li>
                <li *ngFor="let category of categories.EXPERIENCE">
                  <a [routerLink]="['/'+headerSelectedCity.toLowerCase()+'/exclusives/'+category.slug]"
                    fragment="category"
                    class="{{currentCategoryID === category.id || category.slug == currentCategorySlug? 'active uk-active':''}}"
                    (click)="closeMenu()">{{category.category_name}}</a>
                </li>
              </ul>
            </div>
          </li>
          <li class="uk-open">
            <a class="uk-accordion-title" href="#">DEALS</a>
            <div class="uk-accordion-content mt-1">
              <ul class="hamburger-accord-innerlist ">
                <li>
                  <a [routerLink]="['/'+appService.getCurrentCity().toLowerCase()+'/deals']">All</a>
                </li>
                <li *ngFor="let category of categories.STANDARD">
                  <a [routerLink]="['/'+headerSelectedCity.toLowerCase()+'/deals/'+category.slug]"
                    class="{{currentCategoryID === category.id || category.slug == currentCategorySlug? 'active uk-active':''}}"
                    (click)="closeMenu()">{{category.category_name}}</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="hamburger-accord-outerlist mt-2">
          <li>
            <a href="/blogs/">BLOGS</a>
          </li>
          <li>
            <a [routerLink]="['/faqs']" (click)="closeMenu()">FAQs</a>
          </li>
          <li>
            <a [routerLink]="['/about-us']" (click)="closeMenu()">ABOUT US</a>
          </li>
          <li>
            <a [routerLink]="['/contact-us']" (click)="closeMenu()">CONTACT US</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

</header>


<!--CITY MODEL-->
<div id="modal-close-default" class="uk-modal-container citymodel" uk-modal>
  <div class="uk-modal-dialog uk-modal-body">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <div class="select-city-model">
      <h2 class="uk-modal-title">Choose your City</h2>
      <div class="uk-flex uk-flex-wrap uk-flex-center">
        <div class="city-card-m">
          <a class="{{headerSelectedCity === 'mumbai'?'active':'' }}">
            <img src="assets/images/icons/mumbai.png" alt="" (click)="selectCity('Mumbai')">
            <span>Mumbai</span>
          </a>
        </div>
        <div class="city-card-m">
          <a class="{{headerSelectedCity === 'pune'?'active':'' }}">
            <img src="assets/images/icons/pune.png" alt="" (click)="selectCity('Pune')">
            <span>Pune</span>
          </a>
        </div>


        <div class="city-card-m">
          <a class="{{headerSelectedCity === 'bengaluru'?'active':'' }}">
            <img src="assets/images/city/bangalore.png" alt="" (click)="selectCity('Bengaluru')">
            <span>Bengaluru</span>
          </a>
        </div>
        <div class="city-card-m">
          <a class="{{headerSelectedCity === 'delhi'?'active':'' }}">
            <img src="assets/images/city/delhi.png" alt="" (click)="selectCity('Delhi')">
            <span>Delhi-NCR</span>
          </a>
        </div>

        <!-- city-card-m -->
      </div>
    </div>


  </div>
</div>


<div id="modal-center" class="uk-flex-top" uk-modal="bg-close: false">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <div class="login-signup-wrp">
      <div class="loginSignup-btn login-copy" *ngIf="!hideSignupButtons">
        Sign-up/ Login
        <!-- <a href="javascript:void(0)" class="active openLogin">Login</a>-->
      </div>
      <!-- LOGIN -->
      <div class="login-popup border-form-input">

        <div class="popup-logo mt-4 mb-1 uk-flex uk-flex-center" *ngIf="!OTPReceived">
          <a href="javascript:void(0)">
            <img src="assets/images/popup-logo.png" alt="">
          </a>
        </div>
        <p *ngIf="social_step_2">You're one step closer to be a part of the Things2do community.</p>
        <form #loginForm="ngForm" method="post" *ngIf="!OTPReceived">
          <div class="form-group">
            <div class="uk-inline">
              <span class="uk-form-icon">
                <!--<img src="assets/images/icons/call.png" alt="">-->
                <i class="fa fa-phone"></i>&nbsp;
              </span>
              <input class="uk-input" name="mobile_number" autofocus id="mobile_number" placeholder="Enter Mobile No."
                type="tel" required="required" minlength="10" maxlength="10" [(ngModel)]="loginPayLoad.mobile_number"
                #loginMobileNumber="ngModel">
            </div>
            <div class="error" *ngIf="loginForm.submitted && loginMobileNumber.invalid && (loginMobileNumber.dirty)">

              <div *ngIf="loginMobileNumber.errors?.required">
                Mobile Number is required.
              </div>
            </div>

            <span class="error" *ngIf="errorMessage">{{errorMessage}}</span>

          </div>

          <div class="form-group mt-2">
            <button type="submit" class="btn-yellow btn-full" (click)="doLogin()">
              <i class="fa fa-spinner fa-spin" *ngIf="responseAwaited"></i> Get OTP
            </button>
          </div>
        </form>

        <p class="or-style " *ngIf="!hideSignupButtons">or</p>

        <div class="connect-social mt-2 center-block" *ngIf="!hideSignupButtons">
          <a href="javascript:void(0)" (click)="signInWithSocial('facebook')">
            <img src="assets/images/icons/fb.png" alt=" ">
          </a>
          <a href="javascript:void(0)" (click)="signInWithSocial('google')">
            <img src="assets/images/icons/google.png" alt=" ">
          </a>
        </div>


        <!--OTP CARD-->
        <div class="otp-wrp" *ngIf="OTPReceived">

          <div class="popup-logo mt-1 mb-2 uk-flex uk-flex-center">
            <img src="assets/images/otp-img.png" alt="">
          </div>

          <div class="info">
            <p>We have sent an OTP <br> on your mobile number <span>+91 {{loginPayLoad.mobile_number}}</span></p>
            <a (click)="changeMobileNumber()">Change Mobile Number</a>
          </div>

          <!--OTP POPUP-->
          <div class="otp-popup border-form-input mt-3 mb-2">
            <form #OTPForm="ngForm" method="post">
              <div class="form-group">
                <div class="uk-inline">
                  <span class="uk-form-icon">
                    <img src="assets/images/icons/lock.png" alt="">
                  </span>
                  <input class="uk-input" name="otp" id="otp" placeholder="Enter OTP" type="text" min="0" max="999999"
                    size="6" required="required" maxlength="6" [(ngModel)]="loginPayLoad.otp" #OTPField="ngModel"
                    pattern="\d*" maxlength="6">
                </div>
                <span class="error" *ngIf="OTPField.dirty && OTPField.touched && OTPField.invalid">
                  This field cannot be
                  empty.
                </span>
                <span class="error" *ngIf="errorMessage">{{errorMessage}}</span>
              </div>

              <div class="form-group mt-1">
                <button type="submit" class="btn-yellow btn-full cursor-pointer" [disabled]="!OTPForm.valid"
                  (click)="doOTPVerification()">
                  <i class="fa fa-spinner fa-spin" *ngIf="responseAwaited"></i>
                  Submit
                </button>
              </div>
            </form>
          </div>

          <div class="info">
            <h6>Didn’t recieve the code? Request again</h6>
            <a (click)="resendOTP()">Resend OTP</a> <i class="fa fa-spinner fa-spin" *ngIf="resendOTPinProgress"></i>
            <p *ngIf="receivedResentOTPResponse">OTP have been sent!</p>
          </div>
        </div>
        <!--OTP CARD-->

      </div>
      <!-- login-popup -->

    </div>

  </div>
</div>

<div id="modal-profile" class="uk-flex-top" uk-modal>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <div class="login-signup-wrp">
      <div class="loginSignup-btn">
        <a href="javascript:void(0)" class="active openLogin">Profile</a>
      </div>
      <!-- LOGIN -->
      <div class="login-popup border-form-input">
        <div class="popup-logo mt-5 mb-2 uk-flex uk-flex-center">
          <a href="javascript:void(0)">
            <img src="assets/images/popup-logo.png" alt="">
          </a>
        </div>
        <form [formGroup]="profileForm" method="post">
          <!-- First Name-->
          <div class="form-group">
            <div class="uk-inline">
              <span class="uk-form-icon">
                <!--<img src="assets/images/icons/people.png" alt=""> -->
                <i class="fa fa-user"></i>*
              </span>
              <input class="uk-input" formControlName="first_name" placeholder="First Name" type="text"
                required="required" minlength="4" maxlength="255">
            </div>
            <div class="error"
              *ngIf="profileForm.controls['first_name'].invalid && profileForm.controls['first_name'].touched">
              <div *ngIf="profileForm.controls['first_name'].errors.required">
                First Name is required.
              </div>
            </div>
          </div>
          <!-- Last Name -->
          <div class="form-group">
            <div class="uk-inline">
              <span class="uk-form-icon">
                <!--<img src="assets/images/icons/people.png" alt="">-->
                <i class="fa fa-user"></i>*
              </span>
              <input class="uk-input" formControlName="last_name" placeholder="Last Name" type="text"
                required="required" minlength="4" maxlength="255">
            </div>
            <div class="error"
              *ngIf="profileForm.controls['last_name'].invalid && profileForm.controls['last_name'].touched">
              <div *ngIf="profileForm.controls['last_name'].errors.required">
                Last Name is required.
              </div>
            </div>
          </div>
          <!-- Last Name -->
          <div class="form-group">
            <div class="uk-inline">
              <span class="uk-form-icon">
                <!--<img src="assets/images/icons/mail.png" alt="">--><i class="fa fa-envelope"></i>*
              </span>
              <input class="uk-input" formControlName="email" placeholder="Email" type="email"
                [readonly]="currentUser && currentUser.email && currentUser.email !='' " required="required"
                minlength="4" maxlength="255">
            </div>
            <div *ngIf="profileForm.controls['email'].invalid && profileForm.controls['email'].touched" class="error">
              <div *ngIf="profileForm.controls['email'].errors.required">
                Email is required.
              </div>
              <div *ngIf="profileForm.controls['email'].errors.email">
                Email is not valid.
              </div>
            </div>
          </div>
          <!-- City-->
          <div class="form-group">
            <div class="uk-inline">
              <span class="uk-form-icon">
                <img src="assets/images/icons/city.png" alt="">*
              </span>
              <input class="uk-input" name="city" id="city" formControlName="city" placeholder="Enter City" type="email"
                required="required" minlength="4" maxlength="255">
            </div>
            <div class="error" *ngIf="profileForm.controls['city'].invalid && profileForm.controls['city'].touched">
              <div *ngIf="profileForm.controls['city'].errors.required">
                City is required.
              </div>
            </div>
          </div>
          <span class="error" *ngIf="serverError">{{serverError}}</span>
          <div class="form-group mt-1">
            <button type="submit" class="btn-yellow btn-full" (click)="updateProfile()">
              <i class="fa fa-spinner fa-spin" *ngIf="responseAwaited"></i> Submit
            </button>
          </div>
        </form>
      </div>
      <!-- login-popup -->
    </div>

  </div>
</div>


<!--Search-->